function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Statistic, Button, Skeleton, Space, List, Tag, Descriptions, Divider } from 'antd';
import { Table } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import Common from "../components/includes/Common";
import { PrinterFill, HouseFill } from "react-bootstrap-icons";
import moment from "moment";
import { PersonFill, Cash, WalletFill, CreditCardFill, PeopleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Dashboard = function Dashboard() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    customers = _useState4[0],
    setCustomers = _useState4[1];
  var _useOutletContext = useOutletContext(),
    _useOutletContext2 = _slicedToArray(_useOutletContext, 2),
    newCustomerCreated = _useOutletContext2[0],
    setNewCustomerCreated = _useOutletContext2[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCustomer = _useState6[0],
    setSelectedCustomer = _useState6[1];
  var _useState7 = useState(moment().startOf('month').format()),
    _useState8 = _slicedToArray(_useState7, 2),
    globalFrom = _useState8[0],
    setGlobalFrom = _useState8[1];
  var _useState9 = useState(moment().endOf('month').format()),
    _useState0 = _slicedToArray(_useState9, 2),
    globalTo = _useState0[0],
    setGlobalTo = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    dailyKeyStats = _useState10[0],
    setDailyKeyStats = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    keyStats = _useState12[0],
    setKeyStats = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    revenuePerDept = _useState14[0],
    setRevenuePerDept = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    revenueMonthPerDept = _useState16[0],
    setRevenueMonthPerDept = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    countPerSpeciality = _useState18[0],
    setCountPerSpeciality = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    attendancePerDept = _useState20[0],
    setAttendancePerDept = _useState20[1];
  var _useState21 = useState(),
    _useState22 = _slicedToArray(_useState21, 2),
    revenueEvolution = _useState22[0],
    setRevenueEvolution = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    rpdList = _useState24[0],
    setRpdList = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    rpdmList = _useState26[0],
    setRpdmList = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    apdList = _useState28[0],
    setApdList = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    checkPerList = _useState30[0],
    setCheckPerList = _useState30[1];
  useEffect(function () {
    setIsDataLoading(true);
    console.log('User id ' + Common.currentUser.id);
    axios.all([axios.get(Common.baseApiUrl + "getkeystats/" + moment().startOf('day').format() + "/" + moment().endOf('day').format()), axios.get(Common.baseApiUrl + "getkeystats/" + globalFrom + "/" + globalTo), axios.get(Common.baseApiUrl + "getrevenueperdept/" + globalFrom + "/" + globalTo), axios.get(Common.baseApiUrl + "getrevenueperdept/" + moment().startOf('day').format() + "/" + moment().endOf('day').format()), axios.get(Common.baseApiUrl + "countcheckperspeciality/" + globalFrom + "/" + globalTo), axios.get(Common.baseApiUrl + "getattendanceperdept/" + globalFrom + "/" + globalTo), axios.get(Common.baseApiUrl + "getrevenueevolution")]).then(function (response) {
      var flag = true;
      setIsDataLoading(false);
      setDailyKeyStats(response[0].data.keystats);
      setKeyStats(response[1].data.keystats);

      //RPD MONTH
      setRevenueMonthPerDept(response[2].data.rpd);
      response[2].data.rpd.forEach(function (element) {
        setRpdmList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: element.label,
            revenue: element.revenue
          }]);
        });
      });

      //RPD DAY
      setRevenuePerDept(response[3].data.rpd);
      response[3].data.rpd.forEach(function (element) {
        setRpdList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: element.label,
            revenue: element.revenue
          }]);
        });
      });
      setCountPerSpeciality(response[4].data.countPerSpeciality);
      response[4].data.countPerSpeciality.forEach(function (element) {
        setCheckPerList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: element.label,
            count: element.count
          }]);
        });
      });
      setAttendancePerDept(response[5].data.attendancePerDept);
      response[5].data.attendancePerDept.forEach(function (element) {
        setApdList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: element.label,
            count: element.count
          }]);
        });
      });

      //setRevenueEvolution(response[1].data.)
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, []);
  var statValueClass = {
    fontSize: '35px',
    textAlign: 'center',
    fontWeight: 'bold'
  };
  var statInvertedClass = {
    fontSize: '35px',
    textAlign: 'center',
    fontWeight: 'bold',
    color: "#EEE"
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
        children: /*#__PURE__*/_jsx("b", {
          children: "DONNEE JOUR EN COURS"
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          sm: 7,
          children: [/*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius",
                style: {
                  background: '#CE3C3E',
                  color: '#EEE'
                },
                children: dailyKeyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statInvertedClass,
                  title: /*#__PURE__*/_jsx("b", {
                    style: {
                      color: '#EEE'
                    },
                    children: "Total Nouveaux patients"
                  }),
                  value: dailyKeyStats.patientCount
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: dailyKeyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statValueClass,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Nbre consultations"
                  }),
                  value: dailyKeyStats.mcheckCount
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 12,
              md: 12,
              sm: 12,
              children: /*#__PURE__*/_jsxs("div", {
                className: "cool-radius white-bg",
                children: [dailyKeyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statValueClass,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Total Encaissements"
                  }),
                  value: dailyKeyStats.totalRevenue
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: dailyKeyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                      valueStyle: null,
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Cash"
                      }),
                      value: dailyKeyStats.totalCash
                    }) : /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: dailyKeyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                      valueStyle: null,
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Conventionn\xE9s"
                      }),
                      value: dailyKeyStats.totalInsurance
                    }) : /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })
                  })]
                })]
              })
            })]
          }), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "DONNEE MOIS EN COURS"
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius",
                style: {
                  background: '#1B68AE',
                  color: '#EEE'
                },
                children: keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statInvertedClass,
                  title: /*#__PURE__*/_jsx("b", {
                    style: {
                      color: '#EEE'
                    },
                    children: "Total Nouveaux patients"
                  }),
                  value: keyStats.patientCount
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statValueClass,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Nbre consultations"
                  }),
                  value: keyStats.mcheckCount
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsxs("div", {
                className: "cool-radius white-bg",
                children: [keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                  valueStyle: statValueClass,
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Total Encaissements"
                  }),
                  value: keyStats.totalRevenue
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                      valueStyle: null,
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Cash"
                      }),
                      value: keyStats.totalCash
                    }) : /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
                      valueStyle: null,
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Conventionn\xE9s"
                      }),
                      value: keyStats.totalInsurance
                    }) : /*#__PURE__*/_jsx(Skeleton, {
                      active: true
                    })
                  })]
                })]
              })
            })]
          }), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: "TOTAL CA JOUR EN COURS/DEPT"
              })
            }), /*#__PURE__*/_jsx(List, {
              itemLayout: "horizontal",
              dataSource: rpdList,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsxs(List.Item, {
                  children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.label
                    })
                  }), /*#__PURE__*/_jsx(Tag, {
                    color: "#CE3B3E",
                    children: item.revenue.toLocaleString('Fr') + " GNF"
                  })]
                });
              }
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: "TOTAL CA MOIS EN COURS/DEPT"
              })
            }), /*#__PURE__*/_jsx(List, {
              itemLayout: "horizontal",
              dataSource: rpdmList,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsxs(List.Item, {
                  children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.label
                    })
                  }), /*#__PURE__*/_jsx(Tag, {
                    color: "#1B68AE",
                    children: item.revenue.toLocaleString('Fr') + " GNF"
                  })]
                });
              }
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              lg: 12,
              md: 12,
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsx("h5", {
                  style: {
                    color: '#1B66AE'
                  },
                  children: "STATS DE FREQUENTATION MOIS EN COURS"
                }), /*#__PURE__*/_jsx(List, {
                  itemLayout: "horizontal",
                  dataSource: apdList,
                  renderItem: function renderItem(item) {
                    return /*#__PURE__*/_jsxs(List.Item, {
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.label
                        })
                      }), /*#__PURE__*/_jsx(Tag, {
                        color: "#f50",
                        children: item.count.toLocaleString('Fr')
                      })]
                    });
                  }
                })]
              })
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 5,
          md: 5,
          children: [/*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "DONNEE DE PRISE EN CHARGE"
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            children: keyStats != null ? /*#__PURE__*/_jsx(Statistic, {
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total soci\xE9t\xE9s"
              }),
              value: keyStats.totalCompanies
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          }), /*#__PURE__*/_jsx(Row, {})]
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "REPARTITION CONSULTATIONS"
            }), /*#__PURE__*/_jsx(List, {
              itemLayout: "horizontal",
              dataSource: checkPerList,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsxs(List.Item, {
                  children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.label
                    })
                  }), /*#__PURE__*/_jsx(Tag, {
                    color: "red",
                    children: item.count.toLocaleString('Fr')
                  })]
                });
              }
            })]
          })
        })]
      })]
    })
  });
};
export default Dashboard;